(function () {
  function initClientTestimonials(root) {
    if (!root || root.dataset.clientReady === 'true') return;

    var shell = root.querySelector('slider-component');
    var slider = root.querySelector('[id^="Slider-"]');
    var slides = slider ? Array.prototype.slice.call(slider.querySelectorAll('.client-testimonials__slide')) : [];
    var bullets = Array.prototype.slice.call(root.querySelectorAll('.client-testimonials__bullet'));
    if (!shell || !slider || slides.length < 2) return;

    root.dataset.clientReady = 'true';

    function perView() {
      return window.matchMedia('(min-width: 750px)').matches ? 3 : 1;
    }

    function pageCount() {
      return Math.max(1, slides.length - perView() + 1);
    }

    function update() {
      var step = shell.sliderItemOffset || 0;
      var pages = pageCount();
      var index = 0;
      if (step) index = Math.round(Math.abs(slider.scrollLeft) / Math.abs(step));
      index = Math.max(0, Math.min(pages - 1, index));
      var desktop = perView() === 3;

      bullets.forEach(function (bullet, bulletIndex) {
        var visible = bulletIndex < pages;
        bullet.hidden = !visible;
        bullet.classList.toggle('is-active', visible && bulletIndex === index);
      });
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-offset', desktop && slideIndex === index + 1);
      });
    }

    function maxScroll() {
      return Math.max(0, slider.scrollWidth - slider.clientWidth);
    }

    slider.addEventListener('scroll', update, { passive: true });
    slider.addEventListener('scroll', function () {
      var max = maxScroll();
      var next = shell.querySelector('[name="next"]');
      var prev = shell.querySelector('[name="previous"]');
      if (next && Math.abs(slider.scrollLeft) >= max - 2) next.setAttribute('disabled', 'disabled');
      if (prev && Math.abs(slider.scrollLeft) <= 2) prev.setAttribute('disabled', 'disabled');
    }, { passive: true });

    bullets.forEach(function (bullet) {
      bullet.addEventListener('click', function () {
        var index = Number(bullet.dataset.index) || 0;
        var step = shell.sliderItemOffset || 0;
        slider.scrollTo({ left: step * index, behavior: 'smooth' });
      });
    });

    if (window.ResizeObserver) new ResizeObserver(update).observe(slider);
    if (shell.initPages) shell.initPages();
    update();
  }

  function initAllClientTestimonials() {
    document.querySelectorAll('[data-client-testimonials]').forEach(initClientTestimonials);
  }

  customElements.whenDefined('slider-component').then(initAllClientTestimonials);

  document.addEventListener('shopify:section:load', function (event) {
    var section = document.getElementById('ClientTestimonials-' + event.detail.sectionId);
    initClientTestimonials(section);
  });
})();
